import { createAsyncThunk } from '@reduxjs/toolkit';
import type SocureApi from 'api/SocureApi';
import { DEBOUNCE_TIMEOUT } from 'thunks/thunks.config';
import debounce from 'utils/debounce';
import { logger } from 'utils/logger';

export const getDocumentVerificationResultThunk = (api: SocureApi) => {
  const debouncedApiCall = debounce(
    (data: { applicationId: string }) => api.getDocumentVerificationResult(data),
    DEBOUNCE_TIMEOUT,
  );

  return createAsyncThunk('socure/getDocVResult', async (data: { applicationId: string }) => {
    try {
      logger.info(`Get document verification result for application ${data.applicationId}`);

      return await debouncedApiCall(data);
    } catch (error) {
      logger.error(
        `Failed to get document verification result for application ${data.applicationId}`,
        error,
      );
      throw error;
    }
  });
};
